import {TextField, SxProps, Theme} from '@mui/material'
import {TFunction} from 'i18next'
import React from 'react'

import {TaskRepetitionUnit, CustomTaskRepetition} from '@hconnect/common/types'

type Props = {
  t: TFunction
  sx?: SxProps<Theme>
  settings: CustomTaskRepetition
  onChange: (value: number) => void
}

const upperLimit: Record<TaskRepetitionUnit, number> = {
  daily: 365,
  weekly: 53,
  monthly: 12,
  yearly: 5
}

const translationKey: Record<TaskRepetitionUnit, string> = {
  daily: 'recurringDialog.day',
  weekly: 'recurringDialog.week',
  monthly: 'recurringDialog.month',
  yearly: 'recurringDialog.year'
}

export function TaskRepetitionInterval({t, settings, onChange, sx}: Readonly<Props>) {
  const min = 1
  const max = upperLimit[settings.repetition]

  return (
    <>
      <TextField
        sx={sx}
        data-test-id="task-custom-repetition-interval"
        inputProps={{'data-test-id': 'task-custom-repetition-interval-input'}}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          let next = Number.parseInt(event.target.value, 10)

          if (!next || Number.isNaN(next) || next < min) {
            next = min
          } else if (next > max) {
            next = max
          }

          onChange(next)
        }}
        type="number"
        value={settings.repeatEvery}
        variant="outlined"
      />
      {t(translationKey[settings.repetition], {
        count: settings.repeatEvery ?? 1
      })}
    </>
  )
}
